import { render, staticRenderFns } from "./inviter_money.vue?vue&type=template&id=73120bcd&scoped=true&"
import script from "./inviter_money.vue?vue&type=script&lang=js&"
export * from "./inviter_money.vue?vue&type=script&lang=js&"
import style0 from "./inviter_money.vue?vue&type=style&index=0&id=73120bcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73120bcd",
  null
  
)

export default component.exports